import React from 'react';
import { ReactComponent as TreeLeaf } from '../../assets/image/carbon/loader-tree.svg';

const Loader = ({ customClass, viewType = 'circle-spinner' }) => {
  if (viewType === 'leaves-spinner') {
    return (
      <div className="leaves__wrapper" style={{ '--total': 6 }}>
        <div className="leaf__wrapper" style={{ '--i': 0 }}><TreeLeaf /></div>
        <div className="leaf__wrapper" style={{ '--i': 1 }}><TreeLeaf /></div>
        <div className="leaf__wrapper" style={{ '--i': 2 }}><TreeLeaf /></div>
        <div className="leaf__wrapper" style={{ '--i': 3 }}><TreeLeaf /></div>
        <div className="leaf__wrapper" style={{ '--i': 4 }}><TreeLeaf /></div>
        <div className="leaf__wrapper" style={{ '--i': 5 }}><TreeLeaf /></div>
      </div>
    );
  }

  return (
    <div className={`lds-ring ${customClass}`}>
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default Loader;
